import { FC, PropsWithChildren, ReactNode } from 'react';
import TooltipContainer from '../TooltipContainer/TooltipContainer';
import { ReactComponent as InfoIcon } from '../../../assets/svg/InfoIconLight.svg';

/**
 * An (i) icon that reveals explanatory copy on hover — the pattern used next to field labels
 * (e.g. Sanktionslistor, Kollektivavtal) to explain what a data source covers.
 *
 * `children` is the tooltip content; pass `label` to render the icon inline after a label,
 * or omit it when the surrounding markup already lays the label out.
 */
const InfoTooltip: FC<PropsWithChildren<{ label?: ReactNode }>> = ({ label, children }) => {
  const icon = (
    <TooltipContainer renderReferenceComponent={(className, ref) => (
      <span className={className} ref={ref} style={{ display: 'inline-flex', cursor: 'pointer' }}>
        <InfoIcon />
      </span>
    )}>
      <div style={{ padding: '8px 12px', maxWidth: 300, fontSize: 13, lineHeight: 1.5 }}>{children}</div>
    </TooltipContainer>
  );

  if (label === undefined) return icon;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      {label}
      {icon}
    </span>
  );
};

export default InfoTooltip;
